import React from 'react';


export default function Topbar() {
    return (
        <div class=" bg-regal-blue  z-[2000]">
            <p class="text-white text-center text-sm m-0 py-2">We're Growing! Fairpay is exanding to UAE. Soon users can buy crypto using AED.</p>
        </div>
    );
}